<div *ngIf="debug$ | async" class="debug" [class.pane-visible]="isVisible">
  #{{ item.order }} Debug info -> формат: {{ format }}, учитываем данные: {{ hasContent }}, показываем: {{ isVisible }}
  <span class="link" (click)="showMoreInfoDebug()">[More info]</span>
</div>
<div
     class="library-pane"
     [ngClass]="format"
     [class.visible]="isVisible"
     [class.debug-outline]="debug$ | async"
     [class.mobile]="!deviceService.isDesktop()">
  <span inViewport (inViewportAction)="onInViewportTopChange($event)"></span>
  <ng-template pane-container></ng-template>
  <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
</div>
